module.exports = __webpack_public_path__ + "img/sm_logo.833d4744.png";